import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFarbwelt, useTestId } from "@/hooks";
import { Box } from "@gemini/core";
import { useEffect, useRef, useState } from "react";
import { FARBWELT_TOP_OFFSET } from "./constants";
import { FarbweltLogo } from "./FarbweltLogo";
export const FarbweltStickyBanner = () => {
    const testId = useTestId("Farbwelt.StickyBanner");
    const stickyRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
    const { bgColor, logo, isFarbweltActive, providerName, textColor } = useFarbwelt();
    const handleScroll = () => {
        if (stickyRef.current) {
            const offset = FARBWELT_TOP_OFFSET;
            const stickyPosition = stickyRef.current.getBoundingClientRect().top + offset;
            const scrollPosition = window.scrollY;
            if (scrollPosition >= stickyPosition) {
                setIsVisible(true);
            }
            else {
                setIsVisible(false);
            }
        }
    };
    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    const hasBanner = isFarbweltActive && (bgColor || logo);
    if (!hasBanner)
        return null;
    return (_jsxs(Box, { ref: stickyRef, display: {
            "breakpoint.base": "none",
            "breakpoint.lg": "flex",
        }, position: "sticky", top: "0", gridColumn: "col-start / col-end", transitionDuration: "motionDuration.300", transitionTimingFunction: "motionEasing.linear", paddingVertical: "spacing.8", paddingHorizontal: "spacing.80", alignItems: "center", zIndex: "zIndex.3", borderBottomColor: "color.border.light.default", borderBottomWidth: "borderWidth.1", borderBottomStyle: "solid", visibility: isVisible ? "visible" : "hidden", opacity: isVisible ? "opacity.full" : "opacity.none", height: isVisible ? "sizing.72" : "0px", unsafe_style: {
            backgroundColor: bgColor,
        }, children: [_jsx(FarbweltLogo, { testId: `${testId}.Logo`, size: "56" }), _jsx(Box, { as: "span", marginLeft: "spacing.80", typography: "typography.body.16.bold", color: textColor, children: providerName })] }));
};
